<section class="main">
  <h3>
    <span>
      <img
        style="cursor: pointer"
        (click)="back()"
        src="assets/images/mangeunit/back.png"
      />
    </span>
    Add new client
  </h3>

  <section class="supmain" *ngIf="validForm">
    <form [formGroup]="clientForm">
      <!-- persona info -->
      <div class="mt-4 mb-4">
        <p>Personal information</p>
        <div class="row mb-2">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label>Client name (EN)</label>
              <input
                formControlName="name"
                [ngClass]="{
                  'is-invalid': submitted && ControlForm.name.errors
                }"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label>Client name (AR)</label>
              <input
                formControlName="arabic_name"
                type="text"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <!-- <div class="row mb-2">
                    <div class="col-3">
                        <div class="form-group">
                            <label>National ID number</label>
                            <input type="number" class="form-control">
                        </div>
                    </div>
                </div> -->

        <div class="row">
          <div class="col-12 col-md-3">
            <label>Birth date</label>
            <div class="d-flex align-items-center datePicker">
              <input
                formControlName="birth_date"
                [ngClass]="{
                  'is-invalid': submitted && ControlForm.birth_date.errors
                }"
                class="form-control"
                placeholder="Form"
                [matDatepicker]="picker"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 col-md-3">
            <p>Gender</p>
            <input
              formControlName="gender"
              type="radio"
              id="male"
              value="Male"
            />
            <label class="ms-2" for="male">Male</label><br />
            <input
              formControlName="gender"
              type="radio"
              id="female"
              value="Female"
            />
            <label class="ms-2" for="female">Female</label>
            <div
              class="invalid-feedback"
              *ngIf="submitted && ControlForm.gender.errors"
            >
              Gender is Required
            </div>
          </div>
        </div>

        <div class="row mt-2 ">
          <div class="col-12 col-md-3">
            <p>Status</p>
            <input
              formControlName="verified"
              type="checkbox"
              id="Verified"
              value="true"
            />
            <label class="ms-2" for="Verified">Verified</label><br />
            <input
              formControlName="activated"
              type="checkbox"
              id="Activated"
              value="true"
            />
            <label class="ms-2" for="Activated">Activated</label>
          </div>
        </div>
      </div>

      <!-- Contact information -->
      <div>
        <p>Contact information</p>
        <div class="row mb-2">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label>Email</label>
              <input
                [ngClass]="{
                  'is-invalid': submitted && ControlForm.email.errors
                }"
                formControlName="email"
                type="email"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label>Phone number</label>
              <input
                [ngClass]="{
                  'is-invalid': submitted && ControlForm.phone_number.errors
                }"
                formControlName="phone_number"
                type="text"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label>National id</label>
              <input
                [ngClass]="{
                  'is-invalid': submitted && ControlForm.national_id.errors
                }"
                formControlName="national_id"
                type="text"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <!-- <div class="row mb-2">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Adress</label>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Social link 1</label>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label>Social link 2</label>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                </div> -->
      </div>

      <!-- Other information -->

      <div class="mt-4">
        <p>Other information</p>

        <!-- <div class="row mb-2">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Extension ID</label>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                </div> -->
        <div class="row mb-3">
          <!-- <div class="col-3">
                        <div class="form-group">
                            <label>Relation type</label>
                            <input type="text" class="form-control">
                        </div>
                    </div> -->
          <label>Relation type</label>
          <div class="dropdown mb-0 ">
            <button
              class="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ typeName }}
              <img src="assets/images/mangeunit/arrow.png" />
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                *ngFor="let item of types_arr"
                (click)="getRelationTypeId(item)"
              >
                <a class="dropdown-item">{{ item.name }}</a>
              </li>
            </ul>
          </div>
          <div class="invalid-feedback" *ngIf="submitted && typeId == ''">
            Relation type is Required
          </div>
        </div>
        <div class="row mb-3" *ngIf="typeName == 'Owner'">
          <label>Relation</label>
          <div class="dropdown mb-0 ">
            <button
              class="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ Relation }}
              <img src="assets/images/mangeunit/arrow.png" />
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                *ngFor="let item of relion_arr"
                (click)="getRelationName(item)"
              >
                <a class="dropdown-item">{{ item }}</a>
              </li>
            </ul>
          </div>
          <div class="invalid-feedback" *ngIf="submitted && Relation == ''">
            Relation type is Required
          </div>
        </div>
        <!-- <div class="row mb-2">
                    <div class="col-3">
                        <input type="checkbox">
                        <label class="ms-1">This client is temporary</label>
                    </div>
                </div> -->
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="d-flex align-items-center datePicker">
              <input
                formControlName="valid_from"
                [ngClass]="{
                  'is-invalid': submitted && ControlForm.valid_from.errors
                }"
                class="form-control"
                placeholder="Valid Form"
                [matDatepicker]="pickerform"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="pickerform"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerform></mat-datepicker>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="d-flex align-items-center datePicker">
              <input
                formControlName="valid_to"
                [ngClass]="{
                  'is-invalid': submitted && ControlForm.valid_to.errors
                }"
                class="form-control"
                placeholder="Valid To"
                [matDatepicker]="pickertow"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="pickertow"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickertow></mat-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex  justify-content-end mt-5 mb-2">
        <div>
          <button class="btn me-2">Cancel</button>
          <button class="btn next" (click)="nextDataInForm()">Next</button>
        </div>
      </div>
    </form>
  </section>

  <!-- docments -->
  <section class="docments" *ngIf="!validForm">
    <div class="userPhoto mt-4 mb-4">
      <p>Upload profile picture</p>
      <div *ngIf="!userEditPhtot" class="mt-3">
        <label for="user">
          <img src="assets/images/mangeunit/imageDefault.png" /> </label
        ><br />
        <label for="user" class="upload">Upload photo</label>
        <input (change)="uploadUserPhoto($event)" id="user" type="file" />
      </div>
      <div *ngIf="userEditPhtot" class="imageUserUlpoad mt-3">
        <span (click)="removeUserImage()">X</span>
        <img [src]="url" />
      </div>

      <div *ngIf="erorrUserPhoto" class="alertErorr">
        <span>Pleas upload Profile image</span>
      </div>
    </div>
    <div class="uploadDocs">
      <p class="mb-1">Upload documents</p>
      <span>Upload user ID, contract, or any other important document</span>

      <div class="mt-3">
        <div class="row align-items-center">
          <div class="col-3">
            <mat-form-field>
              <mat-label>Image Type</mat-label>
              <mat-select [(ngModel)]="typeDocName"  (selectionChange)="typechoose($event.value)">
                <mat-option value="ID_Passport">
                  ID/Passport
                </mat-option>
                <mat-option value="Drivers_License">
                  Drivers License
                </mat-option>
                <mat-option value="Birth_Certificate">
                  Birth Certificate
                </mat-option>
                <mat-option value="Other">
                  Other
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4">
            <input
              type="file"
              multiple
              (change)="uploadDocmentsClient($event)"
            />
            <!-- <div>
              <label for="userDoc">
                <img src="assets/images/mangeunit/imageDefault.png" /> </label
              ><br />
              <label for="userDoc" class="upload">Upload documents</label>
              <input
                multiple
                (change)="uploadDocmentsClient($event)"
                id="userDoc"
                type="file"
              />
            </div> -->
          </div>
        </div>
        <div *ngIf="status_input_type_name">
          <div class="row">
            <div class="col-6">
              <label>Image Type Name</label>
              <input [(ngModel)]="typeInputName" (input)="inputChange($event)" type="text" class="form-control" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="userDocEditPhtot" class="d-flex mt-3">
        <div
          class="imageUserUlpoad docmentsImages ms-3 "
          *ngFor="let item of docmentImage"
        >
          <span (click)="removeDocImage(item)">X</span>
          <img *ngIf="item.file == false" [src]="item.url" />
          <p *ngIf="item.file == true">{{ item.url }}</p>
          <h5>{{ item.name }}</h5>
        </div>
      </div>

      <!-- <div class="addDocs mt-3">
                <img src="assets/images/mangeunit/plus.png">
            </div> -->
    </div>
    <div *ngIf="erorrDocmentPhoto" class="alertErorr">
      <span>Pleas upload Document</span>
    </div>

    <div class="d-flex  justify-content-end mt-5 mb-2">
      <div>
        <button class="btn me-2">Back</button>
        <button (click)="createClient()" class="btn next">
          Create profile
        </button>
      </div>
    </div>
  </section>
</section>
